import BoxStatistical from '@/components/Statistical/BoxStatistical'
import { INVOICE_STATUS } from '@/modules/Customer/constants'
import { getCustomerInvoiceStatistical } from '@/modules/Customer/services'
import { formatCurrency } from '@/utils/function'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface StatisticalProps {
    customerID: number
}

const Statistical: React.FC<StatisticalProps> = ({ customerID }) => {
    const { data, renderState, isFetching } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.CUSTOMERS_INVOICES, customerID],
        queryFn: () =>
            getCustomerInvoiceStatistical({ customerID: customerID }),
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    const dataStatistical = [
        {
            label: 'total',
        },
        {
            label: 'total-paid',
            value: [INVOICE_STATUS.Paid, INVOICE_STATUS.Done],
        },
        {
            label: 'total-not-paid',
            value: [INVOICE_STATUS.WaitingConfirm, INVOICE_STATUS.Approved],
        },
        {
            label: 'total-cancalled',
            value: [INVOICE_STATUS.Cancelled, INVOICE_STATUS.Rejected],
        },
    ]

    return (
        <div
            data-tour="invoices-statistical"
            className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4"
        >
            {dataStatistical?.map((i, index) => {
                const totalValue = data?.results
                    ?.filter((item) =>
                        i.value ? i.value?.includes(item?.invoice_status) : true
                    )
                    ?.reduce((final, i) => (final += i.total_amount || 0), 0)

                return (
                    <BoxStatistical
                        key={index}
                        label={i?.label}
                        helperText={`${i.label}-description`}
                        loading={isFetching}
                    >
                        {formatCurrency(totalValue || 0)}
                    </BoxStatistical>
                )
            })}
        </div>
    )
}

export default Statistical
